export default __webpack_public_path__ + "static/ifc-tablet-d55a486ef33f533506f2406b9707d70b.png";